import { checkUserActivity } from "meta/features/user-activity";
import { useEffect } from "react";
import { useRootSelector } from "screens/Root/hooks/useAppSelector";
export const useInacivityAutoLogout = () => {
    const { inactivityLogoutActive, tabs, headlessLoginResult } = useRootSelector();
    const notReadyToLogout = Object.values(tabs).filter(tab => !tab.readyToAutoLogout);
    const readyToLogout = inactivityLogoutActive && notReadyToLogout.length == 0;
    if (headlessLoginResult)
        return;
    useEffect(() => {
        let interval = setInterval(checkUserActivity, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    useEffect(() => {
        if (!readyToLogout)
            return;
        window.RootAPI.Navigation.logout();
    }, [readyToLogout]);
    useEffect(() => {
        if (inactivityLogoutActive) {
            setTimeout(() => { window.RootAPI.Navigation.logout(); }, 1000 * 50);
        }
    }, [inactivityLogoutActive]);
};
